import { useCallback, useMemo, useState } from 'react'

import Document from './document'
import Information from './information'
import Market from './market'
import SellingDetails from './selling-details'
import Transaction from './transaction'

export enum TabsContentPTOV2 {
  DETAILS = 0,
  DOCUMENT = 1,
  SELLING_DETAILS = 2,
  TRANSACTION = 3,
  MARKET = 4,
}

const Content = () => {
  const [tab, setTab] = useState(TabsContentPTOV2.DETAILS)

  const CONTENT_TABS = useMemo(() => {
    return [
      {
        value: TabsContentPTOV2.DETAILS,
        label: 'Details',
      },
      {
        value: TabsContentPTOV2.DOCUMENT,
        label: 'Document',
      },
      {
        value: TabsContentPTOV2.SELLING_DETAILS,
        label: 'Selling Details',
      },
      {
        value: TabsContentPTOV2.TRANSACTION,
        label: 'Transaction',
      },
      {
        value: TabsContentPTOV2.MARKET,
        label: 'Market',
      },
    ]
  }, [])

  const renderContent = useCallback(() => {
    switch (tab) {
      case TabsContentPTOV2.DETAILS:
        return <Information />
      case TabsContentPTOV2.DOCUMENT:
        return <Document />
      case TabsContentPTOV2.SELLING_DETAILS:
        return <SellingDetails />
      case TabsContentPTOV2.TRANSACTION:
        return <Transaction />
      case TabsContentPTOV2.MARKET:
        return <Market />
      default:
        return <div>Details</div>
    }
  }, [tab])

  return (
    <>
      <div className="tab-group">
        {CONTENT_TABS.map((contentTab, index) => {
          return (
            <p
              key={index}
              className={tab === contentTab.value ? 'selected' : ''}
              onClick={() => {
                setTab(contentTab.value)
              }}
            >
              {contentTab.label}
            </p>
          )
        })}
      </div>
      {renderContent()}
    </>
  )
}

export default Content
